import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import style from '../style.module.less';

const ViewDescription = ({ isDescriptionExpanded = false, toggleDescription = noop }) => {
  if (isDescriptionExpanded) {
    return (
      <div className={style['description-link']} onClick={toggleDescription}>
        <FormattedMessage defaultMessage='Hide Description' description='items.hideDescription' id='j0xEWl' />
      </div>
    );
  }
  return (
    <div className={style['description-link']} onClick={toggleDescription}>
      <FormattedMessage defaultMessage='View Description' description='items.viewDescription' id='wY0P+g' />
    </div>
  );
};

ViewDescription.propTypes = {
  isDescriptionExpanded: PropTypes.bool,
  toggleDescription: PropTypes.func,
};

export default ViewDescription;
